import * as Sentry from '@sentry/react';
import PolyglotMissingKey from 'App/Errors/PoliglotMissingKeyError';
import { consoleInfoLog, isProd } from 'App/Helpers';
import Polyglot from 'node-polyglot';

import Bulgarian from './translations/bg.json';
import English from './translations/en.json';
import EnglishZa from './translations/enza.json';
import Spanish from './translations/es.json';
import SpanishCl from './translations/escl.json';
import SpanishPe from './translations/espe.json';
import Greek from './translations/gr.json';
import Italian from './translations/it.json';
import Portuguese from './translations/pt.json';
import Romanian from './translations/ro.json';
import Serbian from './translations/sr.json';

const polyglot = new Polyglot({
    allowMissing: true,
    onMissingKey: (error) => {
        isProd()
            ? Sentry.captureException(new PolyglotMissingKey(error))
            : consoleInfoLog(`Polyglot Key Missing: ${error.message}`, 'fail');
    },
});

polyglot.extend({
    pt: Portuguese,
    en: English,
    enza: EnglishZa,
    ro: Romanian,
    bg: Bulgarian,
    gr: Greek,
    it: Italian,
    es: Spanish,
    espe: SpanishPe,
    escl: SpanishCl,
    sr: Serbian,
});

export default polyglot;
